import { ITokens } from "./../../types/auth";
import {
  CognitoRefreshToken,
  CognitoAccessToken,
  CognitoIdToken,
  CognitoUser,
  CognitoUserSession,
  CognitoUserPool,
} from "amazon-cognito-identity-js";
import config from "../../config";

type DecodeFunc = (tokens: ITokens) => [any | undefined, CognitoUser | undefined];
export const decodeCognitoToken: DecodeFunc = ({ idToken, accessToken, refreshToken }) => {
  const { userPoolId, userPoolClientId } = config;
  try {
    const poolData = {
      UserPoolId: userPoolId,
      ClientId: userPoolClientId,
    };

    const userPool = new CognitoUserPool(poolData);
    const IdToken = new CognitoIdToken({ IdToken: idToken });
    const AccessToken = new CognitoAccessToken({ AccessToken: accessToken });
    const RefreshToken = new CognitoRefreshToken({ RefreshToken: refreshToken });
    let userSession = new CognitoUserSession({ IdToken, AccessToken, RefreshToken });
    const payload = userSession.getIdToken().payload;
    const Username = payload["cognito:username"];
    const domusoId = payload["cognito:domusoId"];
    const email = payload["email"];
    const userData = {
      // TODO: Probably preferred_username || username
      Username,
      Pool: userPool,
    };
    const cognitoUser = new CognitoUser(userData);
    // https://stackoverflow.com/questions/55032221/get-aws-cognito-user-from-id-token-retrieved-from-token-endpoint
    // Still need session valid stuff
    cognitoUser.setSignInUserSession(userSession);

    return [userData, cognitoUser];
  } catch (error) {
    // console.log("decodeError: ", error);
    return [undefined, undefined];
  }
};
